import axios from 'axios';

const HEALTHCHECK_TIMEOUT_MS = 5000;

export const HEALTHCHECK_PATH = '/healthcheck';

export const healthClient = axios.create({
    timeout: HEALTHCHECK_TIMEOUT_MS,
    headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache',
    },
});

export async function checkBackendReachable(): Promise<boolean> {
    try {
        const response = await healthClient.get(HEALTHCHECK_PATH, {
            params: { _: Date.now() },
        });

        return response.status >= 200 && response.status < 300;
    } catch {
        return false;
    }
}
